import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Send, MapPin, Phone, Mail, Clock } from 'lucide-react';
export function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
  };
  return <section id="contact" className="py-24 bg-charcoal relative overflow-hidden" data-id="element-43" data-mp="3swoitm3g371t">
      {/* Subtle brick accent */}
      <div className="absolute inset-0 brick-pattern opacity-10" data-id="element-44" data-mp="3oy8wzlj3o4pz"></div>
      <div className="absolute inset-0 bg-charcoal/90" data-id="element-45" data-mp="3k44o2wq9xmm9"></div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-46" data-mp="3f6l2tcv5s9kt">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-47" data-mp="3f4i9aiusrybc">
          <span className="text-amber font-medium tracking-widest uppercase text-sm mb-2 block" data-id="element-48" data-mp="3otwdf3m0nn8d">
            Get in Touch
          </span>
          <h2 className="font-serif text-4xl md:text-5xl text-cream" data-id="element-49" data-mp="3f4mf360kx8bt">
            Contact Us
          </h2>
          <div className="w-24 h-1 bg-warm-brown mx-auto mt-6" data-id="element-50" data-mp="314k0bsnkiv0s"></div>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 lg:gap-16" data-id="element-51" data-mp="363wmeb6m7y2b">
          {/* Contact Info Column */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="lg:col-span-2 space-y-8" data-id="element-52" data-mp="2s56tl7qtwkjr">
            <p className="text-gray-400 text-lg leading-relaxed" data-id="element-53" data-mp="23c3p1m1u0zc2">
              Have a question, want to book a private event, or just want to say
              hello? We'd love to hear from you.
            </p>

            <div className="space-y-6 pt-2" data-id="element-54" data-mp="1ubxd44ls87f0">
              <div className="flex items-start" data-id="element-55" data-mp="1ud06cj6kuly3">
                <div className="w-10 h-10 bg-warm-brown/20 flex items-center justify-center flex-shrink-0 mr-4" data-id="element-56" data-mp="1pckobebcoq9s">
                  <MapPin size={18} className="text-amber" data-id="element-57" data-mp="2m0s61wx72kik" />
                </div>
                <div data-id="element-58" data-mp="2i088is8plevw">
                  <h4 className="text-cream font-medium text-sm tracking-wider uppercase mb-1" data-id="element-59" data-mp="2i105a6e1linr">
                    Address
                  </h4>
                  <p className="text-gray-400" data-id="element-60" data-mp="28aorzt8gxx47">
                    207 Broadway St.
                    <br data-id="element-61" data-mp="288uc4tc20v6z" />
                    Paducah, KY 42001
                  </p>
                </div>
              </div>

              <div className="flex items-start" data-id="element-62" data-mp="30ysxadn4o86d">
                <div className="w-10 h-10 bg-warm-brown/20 flex items-center justify-center flex-shrink-0 mr-4" data-id="element-63" data-mp="30y1de02w7yvx">
                  <Phone size={18} className="text-amber" data-id="element-64" data-mp="38clby7ychsg3" />
                </div>
                <div data-id="element-65" data-mp="3d9tz6mycomo7">
                  <h4 className="text-cream font-medium text-sm tracking-wider uppercase mb-1" data-id="element-66" data-mp="3dbesk98xhzkh">
                    Phone
                  </h4>
                  <p className="text-gray-400" data-id="element-67" data-mp="3mbbbdu8n047m">(270) 933-1707</p>
                </div>
              </div>

              <div className="flex items-start" data-id="element-68" data-mp="3r8bf3yi0kuvk">
                <div className="w-10 h-10 bg-warm-brown/20 flex items-center justify-center flex-shrink-0 mr-4" data-id="element-69" data-mp="3r7igjkt7lboi">
                  <Mail size={18} className="text-amber" data-id="element-70" data-mp="4u0jgabuff87" />
                </div>
                <div data-id="element-71" data-mp="4w4kmkicy04s">
                  <h4 className="text-cream font-medium text-sm tracking-wider uppercase mb-1" data-id="element-72" data-mp="9slgk0vstisf">
                    Email
                  </h4>
                  <p className="text-gray-400" data-id="element-73" data-mp="dw1fx4z95x8t">sun_cheah@yahoo.com</p>
                </div>
              </div>

              <div className="flex items-start" data-id="element-74" data-mp="itt4bp0ov189">
                <div className="w-10 h-10 bg-warm-brown/20 flex items-center justify-center flex-shrink-0 mr-4" data-id="element-75" data-mp="56azlzw47ufx">
                  <Clock size={18} className="text-amber" data-id="element-76" data-mp="1466d29kwztt" />
                </div>
                <div data-id="element-77" data-mp="ex5hks2bw7vk">
                  <h4 className="text-cream font-medium text-sm tracking-wider uppercase mb-1" data-id="element-78" data-mp="evkrben1rb3i">
                    Hours
                  </h4>
                  <div className="text-gray-400 space-y-0.5 text-sm" data-id="element-79" data-mp="9zvmoww6740c">
                    <p data-id="element-80" data-mp="3idupoihk7pnc">Mon – Thu: 4pm – 9pm</p>
                    <p data-id="element-81" data-mp="3ec0v8rxyjhvm">Fri – Sat: 4pm – 10pm</p>
                    <p className="text-warm-brown font-medium" data-id="element-82" data-mp="3edbz0rrekpmq">
                      Sunday: Closed
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Form Column */}
          <div className="lg:col-span-3" data-id="element-83" data-mp="17krx8yotz2ys">
            {submitted ? <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} animate={{
            opacity: 1,
            scale: 1
          }} className="text-center py-16" data-id="element-84" data-mp="17n4ef9mrl9as">
                <div className="w-16 h-16 rounded-full bg-amber/20 flex items-center justify-center mx-auto mb-6" data-id="element-85" data-mp="2pgjyr69kv0kl">
                  <Send size={28} className="text-amber" data-id="element-86" data-mp="2ghyfta071jja" />
                </div>
                <h3 className="font-serif text-2xl text-cream mb-3" data-id="element-87" data-mp="2gk2u8lvpy0xt">
                  Message Sent!
                </h3>
                <p className="text-gray-400" data-id="element-88" data-mp="3895wxx7yj38c">
                  Thank you for reaching out. We'll get back to you shortly.
                </p>
                <button onClick={() => {
              setSubmitted(false);
              setFormData({
                name: '',
                email: '',
                phone: '',
                message: ''
              });
            }} className="mt-8 text-amber hover:text-cream transition-colors text-sm tracking-wider uppercase" data-id="element-89" data-mp="2uhhoc3wx2ww4">
                  Send Another Message
                </button>
              </motion.div> : <motion.form initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.8,
            delay: 0.2
          }} onSubmit={handleSubmit} className="space-y-6" data-id="element-90" data-mp="3ruxrcqoh668z">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-91" data-mp="3476i5vy8e9bx">
                  <div data-id="element-92" data-mp="2z6s9qcspwxdd">
                    <label htmlFor="name" className="block text-cream text-sm font-medium tracking-wider uppercase mb-2" data-id="element-93" data-mp="2z60n3rh3m9z8">
                      Name
                    </label>
                    <input type="text" id="name" required value={formData.name} onChange={e => setFormData({
                  ...formData,
                  name: e.target.value
                })} className="w-full bg-white/5 border border-white/10 text-cream px-4 py-3 focus:outline-none focus:border-amber/60 focus:ring-1 focus:ring-amber/30 transition-colors placeholder-gray-500" placeholder="Your name" data-id="element-94" data-mp="1eohqylb4x9c7" />
                  </div>
                  <div data-id="element-95" data-mp="15pmif2kmbn5q">
                    <label htmlFor="email" className="block text-cream text-sm font-medium tracking-wider uppercase mb-2" data-id="element-96" data-mp="88p8duahq3rh">
                      Email
                    </label>
                    <input type="email" id="email" required value={formData.email} onChange={e => setFormData({
                  ...formData,
                  email: e.target.value
                })} className="w-full bg-white/5 border border-white/10 text-cream px-4 py-3 focus:outline-none focus:border-amber/60 focus:ring-1 focus:ring-amber/30 transition-colors placeholder-gray-500" placeholder="your@email.com" data-id="element-97" data-mp="32q3y3ulv9j3o" />
                  </div>
                </div>

                <div data-id="element-98" data-mp="3qfy7u3aw2rjp">
                  <label htmlFor="phone" className="block text-cream text-sm font-medium tracking-wider uppercase mb-2" data-id="element-99" data-mp="89jmvke7dhbt">
                    Phone{' '}
                    <span className="text-gray-500 normal-case tracking-normal" data-id="element-100" data-mp="mwicd9ti21nw">
                      (optional)
                    </span>
                  </label>
                  <input type="tel" id="phone" value={formData.phone} onChange={e => setFormData({
                ...formData,
                phone: e.target.value
              })} className="w-full bg-white/5 border border-white/10 text-cream px-4 py-3 focus:outline-none focus:border-amber/60 focus:ring-1 focus:ring-amber/30 transition-colors placeholder-gray-500" placeholder="(270) 555-0000" data-id="element-101" data-mp="rt91snr729lz" />
                </div>

                <div data-id="element-102" data-mp="3hcj6g5jc7j2s">
                  <label htmlFor="message" className="block text-cream text-sm font-medium tracking-wider uppercase mb-2" data-id="element-103" data-mp="3hc12snuci2ku">
                    Message
                  </label>
                  <textarea id="message" required rows={5} value={formData.message} onChange={e => setFormData({
                ...formData,
                message: e.target.value
              })} className="w-full bg-white/5 border border-white/10 text-cream px-4 py-3 focus:outline-none focus:border-amber/60 focus:ring-1 focus:ring-amber/30 transition-colors placeholder-gray-500 resize-none" placeholder="Tell us what's on your mind..." data-id="element-104" data-mp="3iortsygf16gf" />
                </div>

                <div className="text-center sm:text-left pt-4" data-id="element-105" data-mp="in9cx2ehlsh">
                  <button type="submit" className="bg-amber text-charcoal px-10 py-4 font-semibold tracking-wide uppercase text-sm hover:bg-cream transition-colors shadow-lg inline-flex items-center space-x-3" data-id="element-106" data-mp="o9spzeg60i3u">
                    <span data-id="element-107" data-mp="28scwsnz8g382">Send Message</span>
                    <Send size={16} data-id="element-108" data-mp="28rblqji7vgqc" />
                  </button>
                </div>
              </motion.form>}
          </div>
        </div>
      </div>
    </section>;
}